import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Globals } from 'app/services/globals'
import { Tag } from 'app/models/tag';
import { FormBuilder, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { tap, finalize } from 'rxjs/operators';
import { SearchRequest } from 'app/models/search-request';
import { DeletedFilesSearchEnum, SearchResponse } from 'app/models/search-results';

@Injectable({ providedIn: 'root' })
export class SearchService {
    constructor(private http: HttpClient, private globals: Globals, private formBuilder: FormBuilder) { 
    }

    currentTagsSubject: BehaviorSubject<Tag[]> = new BehaviorSubject<Tag[]>([]);

    // Use subscription on currentTagsSubject instead
    search(searchRequest: SearchRequest) {
        return this.http.post<SearchResponse>(`${this.globals.api_base_url}/search`, searchRequest);
    }

    // Returns a FormGroup object mapping with the contact's fields with validators sent
    searchRequestFormGroup(searchRequest: SearchRequest = null){
        return this.formBuilder.group({
            query: [searchRequest?.query? searchRequest.query: ''],
            negative_keywords: [searchRequest?.negative_keywords? searchRequest.negative_keywords: ''],
            from: [searchRequest?.from? searchRequest.from: 0],
            
            is_files: [searchRequest?.is_files? searchRequest.is_files: false],
            is_user_storage: [searchRequest?.is_user_storage? searchRequest.is_user_storage: false],
            is_global_storage: [searchRequest?.is_global_storage? searchRequest.is_global_storage: false],
            in_file_contents: [searchRequest?.in_file_contents? searchRequest.in_file_contents: false],
            in_all_file_versions: [searchRequest?.in_all_file_versions? searchRequest.in_all_file_versions: false],
            deleted_search_type: [searchRequest?.deleted_search_type? searchRequest.deleted_search_type: DeletedFilesSearchEnum.EXCLUDE_DELETED],
            user_storage_folders: [searchRequest?.user_storage_folders? searchRequest.user_storage_folders: []],
            global_storage_folders: [searchRequest?.global_storage_folders? searchRequest.global_storage_folders: []],
            metadata: this.formBuilder.group({
                modified: [searchRequest?.metadata?.modified],
                modified_by: [searchRequest?.metadata?.modified_by],
                workflow: [searchRequest?.metadata?.workflow],
                file_class: [searchRequest?.metadata?.file_class]
            }),
            
            is_forms: [searchRequest?.is_forms? searchRequest.is_forms: false],
            in_form_contents: [searchRequest?.in_form_contents? searchRequest.in_form_contents: false],
            forms_folders: [searchRequest?.forms_folders? searchRequest.forms_folders: []],

            is_data: [searchRequest?.is_data? searchRequest.is_data: false],
            data_folders: [searchRequest?.data_folders? searchRequest.data_folders: []],
            data_forms: [searchRequest?.data_forms? searchRequest.data_forms: []],
            data_fields: [searchRequest?.data_fields? searchRequest.data_fields: []]

        });
    }
}